import { Button, Typography } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import { Link } from "react-router-dom";
import useStyles from "./styles";

const ButtonPopover = (props) => {
  const classes = useStyles();
  const buttonType = () => {
    if (get(props, "isLink", "")) {
      return (
        <Link className={classes.detailsLink} to={props.link}>
          {props.label}
        </Link>
      );
    } else {
      return (
        <Button onClick={props.onClick} disabled={get(props, "disabled", "")}>
          <Typography
            variant="body"
            dangerouslySetInnerHTML={{
              __html: props.label,
            }}
          />
        </Button>
      );
    }
  };
  return <>{buttonType()}</>;
};

export default ButtonPopover;
